import React from "react";
import "../styles/Footer.css"
import { Link } from 'react-scroll'

function Footer() {
    return (
        <div className="footer">
            <Link
                activeClass="active"
                to="main"
                spy={true}
                smooth={true}
                offset={-60}
                duration={800}
            ><i className="fa fa-chevron-circle-up fa-4x"></i>
            </Link>
            <footer className="footer mt-auto">
                <div className="justify-content-center">
                    <div className="social">
                        <a href="https://github.com/jking0186" target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-github fa-2x m-2"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/joe-king-iii-60b9a3173/"
                            target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin fa-2x m-2"></i>
                        </a>
                        <a href="https://www.instagram.com/imonly_joeking/" target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-instagram fa-2x m-2"></i>
                        </a>
                        <a href="https://twitter.com/imonly_joeking" target="_blank" rel="noopener noreferrer">
                            <i className="fa fa-twitter fa-2x m-2"></i>
                        </a>
                    </div>
                    <p className="text-secondary">Copyright 2020 Joe King</p>
                </div>
            </footer>
        </div>
    )
};

export default Footer;